import { Link } from '@cred/react-link'
import emitOnClick from '@cred/react-analytics/hoc/emitOnClick'
import withLinkClickEvent from '@cred/react-analytics/hoc/withLinkClickEvent'
import withNofollow from 'components/hocs/with-nofollow'

const LinkWithAnalytics = withLinkClickEvent(emitOnClick(withNofollow(Link)))

export default LinkWithAnalytics
